import { jsx as _jsx } from "react/jsx-runtime";
import { readableDeviceName } from '@iotv/core-services';
import { Stack } from '@mui/material';
import { trueIsBad, trueIsGood, WrapLinkVOB } from '../../../factories/DataGrid';
import { SignalAttributeCell } from '../../../factories/DataGrid/cellFormatters/rangeColors';
import { StripedDataGrid } from '../../../factories/DataGrid/styles/striped';
import { duration, sinceNow } from '../../../NetworkSystem/cellFormatters/valueFormatters';
const debug = process.env.REACT_APP_DEBUG && false;
const common = {
    resizable: false,
    disableColumnMenu: true,
};
const columns = [
    {
        field: 'name',
        headerName: 'Name',
        ...common,
        width: 200,
        renderCell: (p) => WrapLinkVOB(p, 'sk'),
    },
    {
        field: 'id',
        headerName: 'EUI',
        ...common,
        width: 180,
    },
    {
        field: 'isAWOL',
        headerName: 'AWOL?',
        ...common,
        width: 80,
        renderCell: trueIsBad,
    },
    {
        field: 'lastSeen',
        headerName: 'Last Seen',
        ...common,
        width: 200,
        valueFormatter: sinceNow,
    },
    {
        field: '_permittedAWOL',
        headerName: 'Max. AWOL',
        ...common,
        width: 150,
        valueFormatter: duration,
    },
    {
        field: 'deviceType',
        headerName: 'Type',
        ...common,
        width: 150,
        valueFormatter: readableDeviceName,
    },
    {
        field: 'batteryLevel',
        headerName: 'Battery (V)',
        ...common,
        width: 110,
    },
    {
        field: 'fCnt',
        headerName: 'Frames',
        ...common,
        width: 80,
    },
    {
        field: 'rssi',
        headerName: 'RSSI',
        ...common,
        width: 65,
        align: 'center',
        renderCell: (params) => SignalAttributeCell('rssi', params.value),
    },
    {
        field: 'snr',
        headerName: 'SNR',
        ...common,
        width: 65,
        align: 'center',
        renderCell: (params) => SignalAttributeCell('snr', params.value),
    },
    {
        field: 'adr',
        headerName: 'ADR',
        ...common,
        width: 55,
        renderCell: trueIsGood,
    },
    {
        field: 'dr',
        headerName: 'DR',
        ...common,
        width: 50,
        align: 'center',
        renderCell: (params) => SignalAttributeCell('dr', params.value),
    },
];
export const DevicesDataGrid = ({ loading, devices }) => {
    const dataGridProps = {
        columns: columns,
        loading,
        rows: devices,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        density: 'compact',
        hideFooter: devices.length <= 10,
        hideFooterPagination: devices.length <= 10,
        initialState: { sorting: { sortModel: [{ field: 'lastSeen', sort: 'asc' }] }, pagination: { paginationModel: { pageSize: 10 } } },
        sx: {
            [`& .MuiDataGrid-cell`]: {
                ['&[data-field^="rssi"], &[data-field^="snr"], &[data-field^="dr"]']: {
                    padding: 0,
                },
            },
        },
    };
    debug && console.log('Devices DataGrid produced props ', dataGridProps);
    return (_jsx(Stack, { sx: { overflowX: 'auto' }, children: _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps }) }));
};
